import type { PayloadAction } from '@reduxjs/toolkit';
import type { IMessage, MessagesState } from './types';

import { createSlice } from '@reduxjs/toolkit';

const initialState: MessagesState = {
  messages: [],
};

const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    // Add a new message
    addMessage: (state, action: PayloadAction<IMessage>) => {
      state.messages.push(action.payload);
    },

    // Add multiple messages
    addMessages: (state, action: PayloadAction<IMessage[]>) => {
      state.messages.push(...action.payload);
    },

    // Delete a message by id
    deleteMessage: (state, action: PayloadAction<string>) => {
      state.messages = state.messages.filter((message) => message.id !== action.payload);
    },

    // Mark a single message as read
    markAsRead: (state, action: PayloadAction<string>) => {
      const message = state.messages.find((msg) => msg.id === action.payload);
      if (message) {
        message.isRead = true;
      }
    },

    // Mark all messages as read
    markAllAsRead: (state) => {
      state.messages.forEach((message) => {
        message.isRead = true;
      });
    },

    // Clear all messages
    clearMessages: (state) => {
      state.messages = [];
    },
  },
});

export const { addMessage, addMessages, deleteMessage, markAsRead, markAllAsRead, clearMessages } =
  messagesSlice.actions;

export default messagesSlice.reducer;
